import { fetchWithAuthJson } from "../context/FetchWithAuth";
import { baseUrl } from "../utils/config";
import { LogFilters } from "../utils/Type";

export const getAllLogs = async (filters: { date?: string; email?: string; severity?: string }) => {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Token expirer");
  const response = await fetchWithAuthJson(`${baseUrl}/app_api/logs?date=${filters.date}&email=${filters.email}&severity=${filters.severity}`, {
    method: "GET",
    headers: { Authorization: `Bearer ${token}` }
  });

  return response;
}

export const getAllAudit = async (filters: LogFilters) => {
  const token = localStorage.getItem("token");
  if (!token) {
    throw new Error("Token expiré");
  }

  const params = new URLSearchParams();
  if (filters.user) params.append("user", filters.user);
  if (filters.start) params.append("start", filters.start);
  if (filters.end) params.append("end", filters.end);
  if (filters.level) params.append("level", filters.level);

  const queryString = params.toString() ? `?${params.toString()}` : "";
  const url = `${baseUrl}/app_api/audit-logs${queryString}`;

  const response = await fetchWithAuthJson(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  return response;
};